import React, { useState } from 'react'
import { useEffect } from 'react';
import { FaCaretDown, FaCaretUp, FACaretUp, FaChartBar, FaCreditCard, FaHome, FaList, FaMicrosoft, FaPlus, FaPoll, FaPollH, FaUsers } from 'react-icons/fa';

const SideNav = () => {
    const [subMenuOpen, setSubMenuOpen] = useState(false);

    useEffect(() => {
        if(window.innerWidth < "401px"){
            document.getElementById('sidebar').classList.remove('close');
        } 
    }, [])
  return (
    <div class="sidebar close bg-dark">
        
    <div class="logo">
    <i class="image"> <FaMicrosoft /></i>
    <span class="logo-name">User Name </span>
    </div>

    <ul class="nav-list">
    <li>
        <a href="#">
        <i class=""><FaHome /></i>
        <span class="link-name">Dashboard</span>
        </a>

        <ul class="sub-menu blank">
        <li><a href="#" class="link-name">Dashboard</a></li>
        </ul>
    </li>

    <li id='users'
     onClick={(e) => {
        document.getElementById('users').classList.toggle('show');
        setSubMenuOpen(!subMenuOpen);
    }}
    >
        <div class="icon-link">
        <a href="#"  >
            <i><FaUsers /></i>
            <span class="link-name">Users</span>
        </a>
        <i class="arrow" > {document.getElementById('users') && document.getElementById('users').className == 'show' ? <FaCaretUp />: <FaCaretDown />} </i>
        
        </div>

        <ul class="sub-menu">
        <li><a href="#">
            <FaPlus className='me-1' />
            New User
        </a></li>
        <li><a href="#">
            <FaList className='me-1' />
            User List
        </a></li>
        </ul>
    </li>
    <li id='transactions'
     onClick={(e) => {
        document.getElementById('transactions').classList.toggle('show');
        setSubMenuOpen(!subMenuOpen);
    }}
    >
        <div class="icon-link ">
        <a href="#">
            <i class="float-end"><FaChartBar /></i>
            <span class="link-name">Transactions </span>
        </a>
        <i class="arrow" > {document.getElementById('transactions') && document.getElementById('transactions').className == 'show' ? <FaCaretUp />: <FaCaretDown />} </i>
        </div>

        <ul class="sub-menu">
        <li><a href="#">
            <FaPoll className='me-1' />
            Today Transactions
        </a></li>
        <li><a href="#">
            <FaPollH className='me-1' />
            All Transactions
        </a></li>
        </ul>
    </li>
    <li id='payment'
     onClick={(e) => {
        document.getElementById('payment').classList.toggle('show');
        setSubMenuOpen(!subMenuOpen);
    }}
    >
        <div class="icon-link ">
        <a href="#">
            <i class="float-end"><FaCreditCard /></i>
            <span class="link-name">Payments </span>
        </a>
        <i class="arrow" > {document.getElementById('payment') && document.getElementById('payment').className == 'show' ? <FaCaretUp />: <FaCaretDown />} </i>
        </div>

        <ul class="sub-menu">
        <li><a href="#">
            <FaPoll className='me-1' />
            Today Payments
        </a></li>
        <li><a href="#">
            <FaPollH className='me-1' />
            All Payments
        </a></li>
        </ul>
    </li>

    <li>
        <a href="#">
        <i class="fas fa-gear"></i>
        <span class="link-name">Settings</span>
        </a>

        <ul class="sub-menu blank">
        <li><a href="#" class="link-name">Settings</a></li>
        </ul>
    </li>

    <li>
        <div class="profile-details">
        <div class="profile-content">
            <img src="logo.png" alt="" />
        </div>

        <div class="name-job">
            <div class="name">by uxtech</div>
            <div class="job text-center"> www.uxtech.ng </div>
        </div>
        <i class="fas fa-right-to-bracket"></i>
        </div>
    </li>
    </ul>
    </div>
  )
}

export default SideNav